import useMediaQuery from '@mui/material/useMediaQuery';
import theme from 'theme';

export default () => ({
  isMobile: useMediaQuery(theme.breakpoints.maxSm),
  isTablet: useMediaQuery(theme.breakpoints.maxMd),
  isLaptop: useMediaQuery(theme.breakpoints.maxLg),
});
